import { isStandalone, isWrapperApp } from '@/mixins/userAgent';

export default {
  mounted(el) {
    if (!isStandalone && !isWrapperApp) {
      el.setAttribute('target', '_blank');
      el.setAttribute('rel', 'noopener noreferrer');
    }
  },
};
